var BusinessArea;
(function (BusinessArea) {
    BusinessArea[BusinessArea["Common"] = 0] = "Common";
    BusinessArea[BusinessArea["Private"] = 1] = "Private";
    BusinessArea[BusinessArea["Commercial"] = 2] = "Commercial";
    BusinessArea[BusinessArea["Practice"] = 100] = "Practice";
    BusinessArea[BusinessArea["Test"] = 101] = "Test";
})(BusinessArea || (BusinessArea = {}));
export default BusinessArea;
//# sourceMappingURL=businessArea.js.map